import { useParams } from "react-router-dom";
import CustomForm from '../../../core/components/core/Util/Form/CustomForm/CustomForm';
import CustomFormContainer from '../../../core/components/core/Util/Form/CustomForm/CustomFormContainer';
import config from '../../config/config';
import Fetch from '../../../core/util/core/Fetch';
import { useEffect, useState } from 'react';

function Form() {
    const { id } = useParams();
    const [form, setForm] = useState();
    const [formContent, setFormContent] = useState(<>Carregando...</>);

    const endpointBackend = config.endpoints.backend;

    const paths = {
        endpointSave: `${endpointBackend}gci/common-areas/save`,
        endpointGetById: `${endpointBackend}gci/common-areas/getById`,
        urlGoBack: `/gci/common-areas/list`,
        pathView: `/gci/common-areas/view`
    }

    const labels = {
        labelTitleAdd: "Nova Área Comum",
        labelTitleEdit: "Editar Área Comum",
        labelTitleView: 'Visualizar Área Comum'
    }

    const getForm = (values) => {

        let form = {
            fields: [
                {
                    name: 'name',
                    type: 'text',
                    label: 'Área Comum',
                    validations: {
                        required: true
                    },
                    columnSize: 6
                },
                {
                    name: 'icon',
                    type: 'fileS3',
                    label: 'Arquivo Ícone',
                    validations: {
                        required: false,
                    },
                    columnSize: 6
                }
            ],
            ...paths,
            ...labels,
        }
        form.values = values;
        return form;
    }

    useEffect(() => {
        const load = async () => {
            let values = {};
            if (id) {
                values = await Fetch.post(paths.endpointGetById, { id: id })
            }

            const form = getForm(values);

            setForm(form);
            setFormContent(
                <CustomFormContainer
                    form={form}
                    content={<CustomForm form={form} />} />
            );
        }
        load();
    }, [])

    return (
        <div>
            {formContent}
        </div>
    );
}
export default Form;
